import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import AdminRoute from '../AdminRoute';
import AdminTable from '../AdminTable';
import ConfirmDialog from '../ConfirmDialog';
import { graphql, compose } from 'react-apollo';
import CreateUserMutation from '../../mutations/CreateUser';
import UpdateUserMutation from '../../mutations/UpdateUser';
import UsersFilters from './UserFilters';
import UserForm from './UserForm';
import Modal from '../Modal';
import HeightDownAnimation from '../HeightDownAnimation';
import includes from 'lodash/includes';
import gql from 'graphql-tag';

const DELETE_USER_MUTATION = gql`
	mutation($userID: ID!) {
		deleteUser(userID: $userID) {
			id
			username
			password
			firstName
			lastName
			roles
		}
	}
`;

class AdminUsers extends Component {
	constructor(props) {
		super(props);
		this.removeUser = this.removeUser.bind(this);
		this.editUser = this.editUser.bind(this);

		this.state = {
			showDialog: false,
			showEdit: false,
			recordIdToRemove: null,
			showForm: false,
			userFilter: '',
			editingUserID: null,
			roleFilter: {
				name: 'session-filter',
				value: 'all',
				options: [
					{
						description: 'All roles',
						value: 'all'
					},
					{
						description: 'Admin',
						value: 'admin'
					},
					{
						description: 'Instructor',
						value: 'instructor'
					},
					{
						description: 'Player',
						value: 'player'
					}
				],
				showList: false,
				disabled: false,
				placeholder: 'All roles',
				styles: {
					width: '200px',
					margin: 0
				}
			},
			users: {
				columnsBackground: '#ffe9da',
				columns: [
					{
						label: 'ID',
						key: 'id',
						styles: {
							display: 'none'
						},
						rowColumnStyles: {
							display: 'none'
						}
					},
					{
						label: 'first name',
						key: 'firstName',
						styles: {
							width: '15%'
						},
						rowColumnStyles: {
							width: '15%',
							color: '#3a3a40'
						}
					},
					{
						label: 'last name',
						key: 'lastName',
						styles: {
							width: '15%'
						},
						rowColumnStyles: {
							width: '15%',
							color: '#3a3a40'
						}
					},
					{
						label: 'username (Bocconi ID)',
						key: 'username',
						styles: {
							width: '40%'
						},
						rowColumnStyles: {
							width: '40%'
						}
					},
					{
						label: 'password',
						key: 'password',
						lock: true,
						rowIndexToUnlock: -1,
						columnIndexToUnlock: -1,
						styles: {
							width: '20%'
						},
						rowColumnStyles: {
							width: '20%'
						}
					},
					{
						label: 'roles',
						key: 'rolesOutput',
						styles: {
							width: '15%'
						},
						rowColumnStyles: {
							width: '15%',
							color: '#3a3a40',
							textTransform: 'capitalize'
						}
					},
					{
						label: '',
						key: 'actions',
						styles: {
							width: '8%',
							display: 'flex',
							justifyContent: 'space-between',
							margin: '0 30px 0 auto'
						},
						rowColumnStyles: {
							width: '8%',
							display: 'flex',
							justifyContent: 'space-between',
							margin: '0 30px 0 auto'
						}
					}
				],
				// Actions for each row
				actions: [
					{
						key: 'edit',
						icon: 'edit',
						tooltip: 'Edit user',
						to: null,
						clicked: this.editUser,
						param: 'id'
					},
					{
						key: 'remove',
						icon: 'trash',
						tooltip: 'Remove',
						to: null,
						clicked: this.removeUser,
						param: 'id'
					}
				],
				rows: []
			},
			form: {
				title: 'Add User',
				edit: false,
				inputs: [
					{
						type: 'text',
						name: 'firstName',
						value: '',
						placeholder: 'First Name'
					},
					{
						type: 'text',
						name: 'lastName',
						value: '',
						placeholder: 'Last Name'
					},
					{
						type: 'username',
						name: 'username',
						value: '',
						placeholder: 'Username (Bocconi ID)'
					},
					{
						type: 'password',
						name: 'password',
						value: '',
						placeholder: 'Password'
					}
				],
				selects: [
					{
						type: 'radio',
						label: 'Roles',
						name: 'rolesOutput',
						asArray: true,
						values: [],
						items: [
							{
								value: 'admin',
								label: 'Admin'
							},
							{
								value: 'instructor',
								label: 'Instructor'
							},
							{
								value: 'player',
								label: 'Player'
							}
						]
					}
				],
				cta: 'Create new',
				height: 426
			}
		};

		this.onClickAdd = this.onClickAdd.bind(this);
		this.toggleFormVisibility = this.toggleFormVisibility.bind(this);
		this.toggleModalVisibility = this.toggleModalVisibility.bind(this);
		this.onChangeFormValue = this.onChangeFormValue.bind(this);
		this.onClickRadioValue = this.onClickRadioValue.bind(this);
		this.setFormValue = this.setFormValue.bind(this);
		this.createJsonObject = this.createJsonObject.bind(this);
		this.updateJsonObject = this.updateJsonObject.bind(this);
		this.resetFields = this.resetFields.bind(this);
		this.onClose = this.onClose.bind(this);
		this.onModalClose = this.onModalClose.bind(this);
		this.onChangeFilterValue = this.onChangeFilterValue.bind(this);
		this.onClickRoleFilterSelect = this.onClickRoleFilterSelect.bind(this);
		this.onClickRoleFilterSelectItem = this.onClickRoleFilterSelectItem.bind(
			this
		);
		this.applyFilters = this.applyFilters.bind(this);
		this.onClickShowField = this.onClickShowField.bind(this);
		this.toggleDialog = this.toggleDialog.bind(this);
		this.onClickConfirm = this.onClickConfirm.bind(this);
	}

	componentDidMount() {
		this.setUsers(this.props.users);
	}

	onChangeFilterValue(ev) {
		ev.preventDefault();

		const value = ev.target.value;

		let users = { ...this.state.users };
		let userFilter = value.trim().length > 1 ? value : '';

		this.setState(
			{
				users,
				userFilter
			},
			() => this.applyFilters()
		);
	}

	onClickRoleFilterSelect(ev) {
		ev.preventDefault();
		const roleFilter = { ...this.state.roleFilter };

		roleFilter.showList = !roleFilter.showList;

		this.setState({
			roleFilter
		});
	}

	onClickRoleFilterSelectItem(ev) {
		ev.preventDefault();

		const roleFilter = { ...this.state.roleFilter };
		const value = ev.target.getAttribute('data-value');

		roleFilter.showList = false;
		roleFilter.value = value;

		this.setState(
			{
				roleFilter
			},
			() => this.applyFilters()
		);
	}

	applyFilters() {
		const { roleFilter, userFilter } = this.state;
		const users = { ...this.state.users };

		users.rows =
			roleFilter.value !== 'all'
				? this.props.users.filter(
					item => item.roles.indexOf(roleFilter.value) > -1
				  )
				: this.props.users;

		if (userFilter) {
			users.rows = users.rows.filter(
				user =>
					user.firstName.toLowerCase().includes(userFilter.toLowerCase()) ||
					user.lastName.toLowerCase().includes(userFilter.toLowerCase()) ||
					user.username.toLowerCase().includes(userFilter.toLowerCase())
			);
		}

		this.setState({
			users
		});
	}

	setUsers(data = []) {
		let users = { ...this.state.users };

		users.rows = data;

		this.setState({
			users
		});
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.users !== nextProps.users) {
			this.setUsers(nextProps.users);
		}
	}

	onClickAdd(event) {
		event.preventDefault();

		let form = { ...this.state.form };

		form.title = 'Add user';
		form.edit = false;
		form.cta = 'Create new';

		this.setState(
			{
				form
			},
			() => {
				this.toggleFormVisibility();
			}
		);
	}

	toggleModalVisibility(status) {
		const showEdit = status ? status : !this.state.showEdit;

		this.setState(
			{
				showForm: false,
				showEdit
			},
			() => {
				if (!showEdit) {
					this.resetFields();
				}
			}
		);
	}

	toggleFormVisibility(status) {
		const showForm = status ? status : !this.state.showForm;

		this.setState(
			{
				showForm
			},
			() => {
				if (!showForm) this.resetFields();
			}
		);
	}

	resetFields() {
		const form = { ...this.state.form };

		form.inputs.map(item => {
			item.value = '';
		});

		form.selects.map(item => {
			item.values = [];
		});

		setTimeout(() => {
			this.setState({
				form
			});
		}, 800);
	}

	setFormValue(key = 'inputs', field, value, ignoreToggle = false) {
		const form = { ...this.state.form };
		form[key].map(item => {
			const valueToSet = item.name === field ? value : item.value;

			if (item.hasOwnProperty('asArray') && item.asArray) {
				const curIx = item.values.indexOf(valueToSet);
				if (curIx > -1) {
					if (!ignoreToggle) {
						item.values.splice(curIx, 1);
					}
				} else {
					item.values.push(valueToSet);
				}
			} else {
				item.value = valueToSet;
			}
		});
		this.setState({
			form
		});
	}

	onChangeFormValue(ev) {
		ev.preventDefault();

		const inputName = ev.target.name;
		const value = ev.target.value;

		this.setFormValue('inputs', inputName, value);
	}

	onClickRadioValue(ev) {
		ev.preventDefault();

		const name = ev.target.getAttribute('data-name');
		const value = ev.target.getAttribute('data-value');
		//const index = ev.target.getAttribute('data-index');

		this.setFormValue('selects', name, value);
	}

	createJsonObject(createUser) {
		const {
			form: { inputs, selects }
		} = this.state;
		let data = inputs.reduce(
			(acc, cur) => ({ ...acc, [cur.name]: cur.value }),
			{}
		);
		let roles = selects.reduce(
			(acc, cur) => ({ ...acc, [cur.name]: cur.values }),
			{}
		);
		data = {
			...data,
			roles: roles.rolesOutput
		};
		createUser({
			variables: {
				data
			}
		});
		this.toggleFormVisibility();
	}

	updateJsonObject(updateUser) {
		const {
			editingUserID,
			form: { inputs, selects }
		} = this.state;

		// @todo: Check edit above to set create/edit for Apollo

		let data = inputs.reduce(
			(acc, cur) => ({ ...acc, [cur.name]: cur.value }),
			{}
		);
		let roles = selects.reduce(
			(acc, cur) => ({ ...acc, [cur.name]: cur.values }),
			{}
		);

		data = {
			...data,
			roles: roles.rolesOutput
		};
		updateUser({
			variables: {
				userID: editingUserID,
				data
			}
		});
		this.toggleModalVisibility();
	}

	onClickShowField(ev) {
		const { user } = this.props;
		const id = ev.target.getAttribute('data-id');
		const row = ev.target.getAttribute('data-row');
		const column = ev.target.getAttribute('data-column');
		const key = ev.target.getAttribute('data-field');

		let users = { ...this.state.users };
		const rowUser = users.rows.find( row => row.id === id );
		const isSameUser = rowUser.id === user.id;
		const userIsAdmin = includes( user.roles, 'admin' );
		const rowUserIsPlayer = !includes( rowUser.roles, 'admin' ) && !includes( rowUser.roles, 'instructor' );
		if(rowUserIsPlayer || userIsAdmin || isSameUser ) {
			users.columns.map(columnItem => {
				if (columnItem.key === key) {
					if (
						columnItem.rowIndexToUnlock === row &&
						columnItem.columnIndexToUnlock === column
					) {
						columnItem.rowIndexToUnlock = -1;
						columnItem.columnIndexToUnlock = -1;
					} else {
						columnItem.rowIndexToUnlock = row;
						columnItem.columnIndexToUnlock = column;
					}
				}
			});
		}

		this.setState({
			users
		});
	}

	onClose(ev) {
		ev.preventDefault();

		this.toggleFormVisibility();
	}

	onModalClose(ev) {
		ev.preventDefault();

		this.toggleModalVisibility();
	}

	removeUser(ev) {
		ev.preventDefault();
		const recordIdToRemove = ev.target.getAttribute('data-id');
		this.setState(
			{
				recordIdToRemove
			},
			() => {
				this.toggleDialog();
			}
		);
	}

	editUser(ev) {
		ev.preventDefault();
		const { users } = this.state;
		const userID = ev.target.getAttribute('data-id');
		const user = users ? users.rows.find(user => user.id === userID) : {};
		let form = { ...this.state.form };
		form.title = 'Edit user';
		form.edit = true;
		form.cta = 'Save';

		Object.keys(user).map(key => {
			if (key !== 'rolesOutput') {
				this.setFormValue('inputs', key, user[key]);
			} else {
				user.roles &&
					user.roles.map(role => {
						this.setFormValue('selects', key, role, true);
					});
			}
		});

		this.setState(
			{
				form,
				editingUserID: user.id
			},
			() => {
				this.toggleModalVisibility(true);
			}
		);
	}

	toggleDialog() {
		let showDialog = !this.state.showDialog;

		this.setState({
			showDialog
		});
	}

	onClickConfirm(ev) {
		ev.preventDefault();
		const { deleteUserMutation } = this.props;
		const userID = this.state.recordIdToRemove;
		deleteUserMutation({
			variables: { userID },
			refetchQueries: ['adminQuery']
		});
		this.setState(
			{
				recordIdToRemove: null
			},
			() => {
				this.toggleDialog();
			}
		);
	}

	render() {
		const {
			users,
			showForm,
			showEdit,
			form,
			roleFilter,
			showDialog,
			recordIdToRemove
		} = this.state;
		/*
		if (typeof window !== 'undefined') {
			showEdit || showDialog ? document.body.style.overflow = 'hidden' : document.body.style.overflow = 'auto';
		}*/

		return (
			<CreateUserMutation>
				{createUser => (
					<UpdateUserMutation>
						{updateUser => (
							<div className="AdminUsers">
								{showDialog && (
									<ConfirmDialog
										id={recordIdToRemove}
										title={'Deleting user'}
										description={
											'Are you sure you want to delete this user?<br />Once deleted it cannot be recovered.'
										}
										icon={'trash'}
										show={showDialog}
										confirmClicked={this.onClickConfirm}
										closeDialogClicked={this.toggleDialog}
									/>
								)}
								{showEdit && (
									<Modal
										width={800}
										height={426}
										show={showEdit}
										closeDialogClicked={this.onModalClose}
									>
										{
											<UserForm
												changed={this.onChangeFormValue}
												submitted={() => this.updateJsonObject(updateUser)}
												clicked={this.onClickRadioValue}
												closed={this.onModalClose}
												form={form}
												show={showEdit}
											/>
										}
									</Modal>
								)}
								<AdminRoute
									title="Users"
									subTitle="Users"
									icon="usersColor"
									buttonTheme="salmon"
									buttonCta="Add user"
									filters={
										<UsersFilters
											select={roleFilter}
											selectClicked={this.onClickRoleFilterSelect}
											selectItemClicked={this.onClickRoleFilterSelectItem}
											changed={this.onChangeFilterValue}
										/>
									}
									form={
										<HeightDownAnimation show={showForm} height={426}>
											<UserForm
												changed={this.onChangeFormValue}
												submitted={() => this.createJsonObject(createUser)}
												clicked={this.onClickRadioValue}
												closed={this.onClose}
												form={form}
											/>
										</HeightDownAnimation>
									}
									buttonClicked={this.onClickAdd}
								>
									<AdminTable
										table={users}
										emptyMessage={'No users found'}
										numberOfRows={users.rows.length}
										limit={8}
										showField={this.onClickShowField}
									/>
								</AdminRoute>
							</div>
						)}
					</UpdateUserMutation>
				)}
			</CreateUserMutation>
		);
	}
}

AdminUsers.propTypes = {
	users: PropTypes.arrayOf(PropTypes.object)
};

export default compose(
	graphql(DELETE_USER_MUTATION, { name: 'deleteUserMutation' })
)(AdminUsers);
